import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import socketIO from "socket.io-client";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import moment from "moment";
import { toast } from "react-toastify";

export default function Ticket() {
  const { accessObject, isValid, setIsValid, socket } = useAppContext();

  const [showPage, setShowPage] = React.useState(false);
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [messageValue, setMessageValue] = React.useState("");
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  const [search, setSearch] = useState("");
  const [totalData, setTotalData] = useState(10);
  const [showInfo, setShowInfo] = React.useState(false);
  const chatMessagesRef = React.useRef(null);
  const [showSuggested, setShowSuggested] = React.useState(true);
  const [showImageModal, setShowImageModal] = React.useState(false);
  const [modalImageUrl, setModalImageUrl] = React.useState("");
  const [isImageLoading, setIsImageLoading] = React.useState(true);

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "";
    if (imagePath.startsWith("http://") || imagePath.startsWith("https://") || imagePath.startsWith("data:")) {
      return imagePath;
    }
    const cleanUrl = API_URL.endsWith("/") ? API_URL.slice(0, -1) : API_URL;
    const cleanPath = imagePath.startsWith("/") ? imagePath : `/${imagePath}`;
    return `${cleanUrl}${cleanPath}`;
  };

  const scrollToBottom = () => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTo({
        top: chatMessagesRef.current.scrollHeight,
        behavior: "smooth"
      });
    }
  };

  React.useEffect(() => {
    const timer = setTimeout(() => {
      scrollToBottom();
    }, 100);
    return () => clearTimeout(timer);
  }, [rowValue?.ticketMessages, showPage]);

  const onPaginationChange = (start, end) => {
    setPagination((prev) => {
      if (prev.start === start && prev.end === end) {
        return prev;
      }
      return { start, end };
    });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage((prev) => (prev === value ? prev : value));
    setPagination((prev) => {
      if (prev.start === 0 && prev.end === value) {
        return prev;
      }
      return { start: 0, end: value };
    });
  };

  const LoginSchema = Yup.object().shape({
    title: Yup.string().required("required"),
    description: Yup.string().required("required"),
  });

  React.useEffect(() => {
    getBranch();
  }, [search, pagination.start, pagination.end, showPrePage]);

  React.useEffect(() => {
    if (showPage && rowValue?._id) {
      getSingleTicket(rowValue._id);
    }
  }, [showPage, rowValue?._id]);

  const getSingleTicket = (id) => {
    axios(
      `${API_URL}/api/admin/ticket/get-ticket/${id}`,
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then(({ data: response }) => {
        if (response.status) {
          let ticketData = null;
          if (response.data) {
            if (Array.isArray(response.data)) {
              ticketData = response.data[0];
            } else if (response.data.data) {
              if (Array.isArray(response.data.data)) {
                ticketData = response.data.data[0];
              } else {
                ticketData = response.data.data;
              }
            } else {
              ticketData = response.data;
            }
          }
          if (ticketData) {
            setRowValue(ticketData);
          }
        } else {
          toast.error(response.message || "Failed to fetch ticket details");
        }
      })
      .catch((error) => {
        console.log("getSingleTicket error :::", error);
        toast.error("Failed to fetch ticket details");
      });
  };

  const getBranch = () => {
    setLoader(true);
    const page = Math.floor(pagination.start / showPrePage) + 1;
    const limit = showPrePage;
    axios(
      `${API_URL}/api/admin/ticket/get-ticket?search=${search}&page=${page}&limit=${limit}`,
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then(({ data: response }) => {
        setLoader(false);
        if (response.status) {
          setTableData(response.data.data);
          setTotalData(response.data.totalLength);
        } else {
          toast.error(response.message || "Failed to fetch tickets");
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log("getBranch error :::", error);
        toast.error("Network error: Failed to fetch tickets");
      });
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    setShowInfo(false);
    console.log("item edit value :::", item);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    setRowValue();
    setShowInfo(true);
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateTournament = (value) => {
    console.log("updateTournament value :::", value);
    const body = {
      title: value?.title,
      description: value?.description,
      ticketStatus: parseInt(value?.ticketStatus),
    };

    axios
      .patch(`${API_URL}/api/admin/ticket/update-ticket/${rowValue._id}`, body)
      .then((res) => {
        console.log("update :::", res.data);
        if (res.data.status) {
          successAdd(res.data.message);
          setbuttonLoader(false);
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        setbuttonLoader(false);
        console.log("update err :::", err);
        warningAlert();
      });
  };

  const addNewTournament = (value) => {
    const body = {
      title: value.title,
      description: value.description,
      ticketStatus: parseInt(value.ticketStatus),
    };

    axios(`${API_URL}/api/admin/ticket/add-ticket`, {
      method: "POST",
      credentials: "include",
      data: body,
    })
      .then((result) => {
        setbuttonLoader(false);
        console.log("handleSubmit add ticket result :::", result.data);
        if (result.data.status) {
          successAdd(result.data.message);
        } else {
          toast.error(result.data.message);
        }
      })
      .catch((err) => {
        setbuttonLoader(false);
        console.log("handleSubmit err :::", err);
        warningAlert();
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this ticket. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Deleted!"
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        confirmBtnBsStyle="success"
      >
        Ticket Deleted Successfully!
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    axios
      .delete(`${API_URL}/api/admin/ticket/delete-ticket/${e._id}`)
      .then((res) => {
        console.log(res);
        if (res.data.status) {
          successDeleted(res.data);
          getBranch();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log("delete err :::", err);
        toast.error("Failed to delete ticket");
      });
  };

  const successAdd = (msg) => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title={msg}
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      ></SweetAlert>
    );
  };

  const successEdit = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Edited successfully!"
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      >
        Your Ticket has been Edited ...
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block" }}
        title="Something Went Wrong .....!"
        onConfirm={() => {
          setAlert(null);
        }}
        confirmBtnBsStyle="success"
      ></SweetAlert>
    );
  };

  const onchangeMessage = async (message) => {
    setMessageValue(message);
  };

  const sendMessageFun = async () => {
    console.log("sendMessageFun...");
    setIsValid(!isValid);

    const adminId = localStorage.getItem("token");
    const data = {
      adminId: adminId,
      ticketId: rowValue._id,
      message: messageValue,
    };
    console.log("data::: ", data);
    socket.emit("ticket-send-message-by-admin", data);
    setMessageValue("");
  };

  React.useEffect(() => {
    const handleReceiveMessage = (data) => {
      console.log("receive_message_admin...", data);
      setRowValue((prevRowValue) => {
        if (prevRowValue && data && data._id === prevRowValue._id) {
          return data;
        } else if (!prevRowValue && data) {
          return data;
        }
        return prevRowValue;
      });
    };
    socket.on("receive_message_admin", handleReceiveMessage);
    return () => {
      socket.off("receive_message_admin", handleReceiveMessage);
    };
  }, [socket]);

  return (
    <>
      {alert}
      {showPage ? (
        <div className="content p-3">
          <div className="card shadow-sm border-0" style={{ borderRadius: '15px' }}>
            <div className="card-header bg-transparent border-0 pt-4 px-4">
              <div className="d-flex justify-content-between align-items-center w-100">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm shadow-sm"
                  onClick={() => setShowPage(false)}
                  style={{ height: '36px', minWidth: '100px', borderRadius: '8px', fontWeight: '600' }}
                >
                  <i className="fas fa-arrow-left mr-2"></i> Back
                </button>
                
                <button
                  type="button"
                  className={`btn btn-sm shadow-sm ${showInfo ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setShowInfo(!showInfo)}
                  style={{ height: '36px', minWidth: '100px', borderRadius: '8px', fontWeight: '600' }}
                >
                  <i className="fas fa-info-circle mr-2"></i> {showInfo ? "Hide Info" : "Info"}
                </button>
              </div>
            </div>
            <div className="card-body p-4">
              <Box sx={{ width: "100%" }}>
                <Formik
                  initialValues={{
                    title: rowValue ? rowValue?.title : "",
                    description: rowValue ? rowValue?.description : "",
                    playerId: rowValue ? rowValue?.playerId : "",
                    ticketStatus: rowValue ? rowValue?.ticketStatus : 4,
                  }}
                  enableReinitialize={true}
                  validationSchema={LoginSchema}
                  onSubmit={(values) => {
                    setbuttonLoader(true);
                    console.log("values...", values);
                    console.log("openValue...", openValue);

                    if (openValue == 1) {
                      addNewTournament(values);
                    }
                    if (openValue == 2) {
                      updateTournament(values);
                    }
                  }}
                >
                  {({ touched, errors, isSubmitting, values }) => (
                    <Form>
                      <div className="row">
                        {/* Chat Column */}
                        <div className={showInfo ? "col-lg-8 col-md-7" : "col-12"}>
                          <div className="chat-container shadow-sm" style={{
                            borderRadius: '15px',
                            border: '1px solid #e2e8f0',
                            overflow: 'hidden',
                            backgroundColor: '#ffffff'
                          }}>
                            {/* Chat Header */}
                            <div className="bg-white border-bottom px-4 py-3 d-flex align-items-start justify-content-between">
                              <div>
                                <h5 className="mb-1 font-weight-bold text-dark" style={{ letterSpacing: '-0.02em', fontSize: '1.25rem', color: '#1e293b' }}>
                                  Ticket #{rowValue?.ticket_id || rowValue?.ticketCode || rowValue?.ticketNo || rowValue?.ticketId || (rowValue?._id ? `TCK-${rowValue._id.substring(rowValue._id.length - 8).toUpperCase()}` : 'N/A')}
                                </h5>
                                <div className="text-muted" style={{ fontSize: '0.85rem' }}>
                                  {rowValue?.description || rowValue?.title || 'No description provided'}
                                </div>
                              </div>
                              <div className="d-flex align-items-center" style={{ marginTop: '4px' }}>
                                <span className="d-flex align-items-center text-muted" style={{ fontSize: '0.85rem', fontWeight: '500', gap: '6px' }}>
                                  <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#22c55e', display: 'inline-block' }}></span>
                                  Connected
                                </span>
                              </div>
                            </div>

                            {/* Chat Messages */}
                            <div className="chat-messages p-4" ref={chatMessagesRef} style={{
                              height: "500px",
                              overflowY: "auto",
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '20px',
                              backgroundColor: '#ffffff'
                            }}>
                              {rowValue?.ticketMessages?.length > 0 ? (
                                rowValue.ticketMessages.map((item, index) => {
                                  const currentMessageDate = item.createdAt ? moment(item.createdAt).format("MMMM DD, YYYY") : "";
                                  const prevMessageDate = index > 0 && rowValue.ticketMessages[index - 1].createdAt
                                    ? moment(rowValue.ticketMessages[index - 1].createdAt).format("MMMM DD, YYYY")
                                    : "";
                                  const showDateDivider = currentMessageDate !== prevMessageDate;

                                  return (
                                    <React.Fragment key={index}>
                                      {showDateDivider && (
                                        <div className="d-flex justify-content-center my-3">
                                          <span className="text-muted px-3 py-1 rounded" style={{ fontSize: '0.75rem', fontWeight: '600', backgroundColor: '#f1f5f9' }}>
                                            {currentMessageDate}
                                          </span>
                                        </div>
                                      )}
                                      <div style={{
                                        display: 'flex',
                                        justifyContent: item.sendType === 0 ? 'flex-end' : 'flex-start',
                                        marginBottom: '16px'
                                      }}>
                                        <div style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: item.sendType === 0 ? 'flex-end' : 'flex-start',
                                          maxWidth: '85%'
                                        }}>
                                          <div style={{
                                            padding: '12px 18px',
                                            borderRadius: item.sendType === 0 ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                                            backgroundColor: item.sendType === 0 ? '#fef08a' : '#f1f5f9', // Soft yellow for admin, light slate-100 for player
                                            color: '#0f172a',
                                            fontSize: '0.9rem',
                                            fontWeight: '500',
                                            border: 'none',
                                            whiteSpace: 'pre-line'
                                          }}>
                                            {item.sendMessage}
                                          </div>
                                          <div style={{
                                            fontSize: '0.7rem',
                                            color: '#94a3b8',
                                            marginTop: '4px',
                                            padding: '0 4px'
                                          }}>
                                            {item.createdAt ? moment(item.createdAt).format("hh:mm A") : ""}
                                          </div>
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  );
                                })
                              ) : (
                                <div className="h-100 d-flex flex-column align-items-center justify-content-center text-muted opacity-50">
                                  <i className="far fa-comments mb-2" style={{ fontSize: '2rem' }}></i>
                                  <div className="small">No messages yet</div>
                                </div>
                              )}
                            </div>

                            {/* Suggested Messages */}
                            {showSuggested && (
                              <div className="suggested-messages-area px-4 py-2 border-top bg-white">
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                  <span style={{ fontSize: '0.75rem', color: '#94a3b8', fontWeight: '600' }}>Suggested messages:</span>
                                  <button
                                    type="button"
                                    className="btn btn-link p-0 text-muted"
                                    onClick={() => setShowSuggested(false)}
                                    style={{ fontSize: '0.9rem', textDecoration: 'none' }}
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                </div>
                                <div className="d-flex flex-wrap" style={{ gap: '8px' }}>
                                  <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm"
                                    style={{ marginRight: '8px', borderRadius: '15px', fontSize: '0.8rem', padding: '4px 12px', border: '1px solid #cbd5e1', color: '#334155', backgroundColor: '#fff', fontWeight: '500' }}
                                    onClick={() => setMessageValue("Thank you")}
                                  >
                                    Thank you
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm"
                                    style={{ borderRadius: '15px', fontSize: '0.8rem', padding: '4px 12px', border: '1px solid #cbd5e1', color: '#334155', backgroundColor: '#fff', fontWeight: '500' }}
                                    onClick={() => setMessageValue("Thanks for reaching out")}
                                  >
                                    Thanks for reaching out
                                  </button>
                                </div>
                              </div>
                            )}

                            {/* Chat Input */}
                            <div className="chat-input-area p-3 bg-white border-top">
                              <div className="d-flex gap-2 align-items-center">
                                <div className="flex-grow-1 position-relative" style={{ marginRight: '10px' }}>
                                  <input
                                    type="text"
                                    className="form-control border-0"
                                    placeholder="Type a message..."
                                    style={{
                                      backgroundColor: '#f1f5f9',
                                      borderRadius: '12px',
                                      padding: '12px 16px',
                                      fontSize: '0.9rem',
                                      color: '#334155',
                                      outline: 'none',
                                      boxShadow: 'none'
                                    }}
                                    value={messageValue}
                                    onChange={(e) => onchangeMessage(e.target.value)}
                                    onKeyPress={(e) => {
                                      if (e.key === 'Enter' && messageValue.trim() !== "") {
                                        e.preventDefault();
                                        sendMessageFun();
                                      }
                                    }}
                                  />
                                </div>
                                <button
                                  type="button"
                                  className="btn d-flex align-items-center justify-content-center"
                                  style={{
                                    height: '40px',
                                    width: '40px',
                                    minWidth: '40px',
                                    borderRadius: '50%',
                                    backgroundColor: messageValue.trim() === "" ? '#cbd5e1' : '#94a3b8',
                                    color: '#fff',
                                    border: 'none',
                                    padding: '0',
                                    cursor: messageValue.trim() === "" ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s'
                                  }}
                                  onClick={() => {
                                    if (messageValue.trim() !== "") {
                                      sendMessageFun();
                                    }
                                  }}
                                  disabled={messageValue.trim() === ""}
                                >
                                  <i className="fas fa-paper-plane" style={{ fontSize: '0.9rem' }}></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Info Panel Column */}
                        {showInfo && (
                          <div className="col-lg-4 col-md-5 mt-4 mt-md-0">
                            <div className="p-4 bg-white border rounded shadow-sm" style={{ borderRadius: '15px', borderColor: '#e2e8f0' }}>
                              <h5 className="mb-4 font-weight-bold text-dark d-flex align-items-center">
                                <i className="fas fa-info-circle text-primary mr-2"></i> Ticket Details
                              </h5>
                              
                              {/* Player Info Section */}
                              {rowValue?.playerId && typeof rowValue.playerId === "object" ? (() => {
                                const player = rowValue.playerId;
                                const copyToClipboard = (text) => {
                                  navigator.clipboard.writeText(text).then(() => {
                                    toast.success("Copied!");
                                  });
                                };
                                const infoRowStyle = {
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "2px",
                                  padding: "10px 14px",
                                  background: "#f8fafc",
                                  borderRadius: "10px",
                                  border: "1px solid #e2e8f0",
                                };
                                const labelStyle = {
                                  fontSize: "0.72rem",
                                  fontWeight: 700,
                                  color: "#94a3b8",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  marginBottom: "2px",
                                };
                                const valueStyle = {
                                  fontSize: "0.9rem",
                                  fontWeight: 600,
                                  color: "#1e293b",
                                };
                                const emptyStyle = {
                                  ...valueStyle,
                                  color: "#cbd5e1",
                                  fontStyle: "italic",
                                  fontWeight: 400,
                                };
                                return (
                                  <div className="mb-4">
                                    {/* Section Header */}
                                    <div className="d-flex align-items-center mb-3" style={{ gap: "8px" }}>
                                      <div style={{ width: "28px", height: "28px", borderRadius: "8px", background: "linear-gradient(135deg, #ffc107 0%, #ff9800 100%)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <i className="fas fa-user" style={{ fontSize: "12px", color: "#1e293b" }}></i>
                                      </div>
                                      <span style={{ fontWeight: 700, fontSize: "0.9rem", color: "#1e293b" }}>Player</span>
                                    </div>

                                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                      {/* Player ID with copy button */}
                                      <div style={{ ...infoRowStyle, flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                        <div>
                                          <div style={labelStyle}>Player ID</div>
                                          <div style={valueStyle}>{player.playerId || "-"}</div>
                                        </div>
                                        {player.playerId && (
                                          <button
                                            type="button"
                                            onClick={() => copyToClipboard(player.playerId)}
                                            style={{ background: "#e2e8f0", border: "none", borderRadius: "8px", padding: "6px 10px", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px", fontSize: "0.75rem", fontWeight: 600, color: "#475569", flexShrink: 0 }}
                                            title="Copy Player ID"
                                          >
                                            <i className="fas fa-copy" style={{ fontSize: "0.7rem" }}></i> Copy
                                          </button>
                                        )}
                                      </div>

                                      {/* Email */}
                                      <div style={infoRowStyle}>
                                        <div style={labelStyle}>Email</div>
                                        {player.email
                                          ? <div style={valueStyle}>{player.email}</div>
                                          : <div style={emptyStyle}>Not provided</div>
                                        }
                                      </div>

                                      {/* Phone */}
                                      <div style={infoRowStyle}>
                                        <div style={labelStyle}>Phone Number</div>
                                        {player.phoneNo
                                          ? <div style={valueStyle}>{player.phoneNo}</div>
                                          : <div style={emptyStyle}>Not provided</div>
                                        }
                                      </div>

                                      {/* Name */}
                                      <div style={infoRowStyle}>
                                        <div style={labelStyle}>Name</div>
                                        {player.name
                                          ? <div style={valueStyle}>{player.name}</div>
                                          : <div style={emptyStyle}>Not provided</div>
                                        }
                                      </div>

                                      {/* Balance */}
                                      <div style={infoRowStyle}>
                                        <div style={labelStyle}>Balance</div>
                                        {player.balance != null
                                          ? <div style={{ ...valueStyle, color: "#16a34a" }}>₹ {player.balance}</div>
                                          : <div style={emptyStyle}>Not available</div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                );
                              })() : (
                                <div className="form-group mb-3">
                                  <label className="small text-muted font-weight-bold">Player Id</label>
                                  <div className="form-control premium-input" style={{ color: "#94a3b8", fontStyle: "italic" }}>
                                    {typeof rowValue?.playerId === "string" ? rowValue.playerId : "No player linked"}
                                  </div>
                                </div>
                              )}

                              <div className="form-group mb-3">
                                <label className="small text-muted font-weight-bold">Title</label>
                                <Field
                                  type="text"
                                  name="title"
                                  placeholder="Enter Title..."
                                  className={`form-control premium-input ${touched.title && errors.title ? "is-invalid" : ""}`}
                                />
                                <ErrorMessage component="div" name="title" className="invalid-feedback" />
                              </div>

                              <div className="form-group mb-3">
                                <label className="small text-muted font-weight-bold">Description</label>
                                <Field
                                  type="text"
                                  name="description"
                                  placeholder="Enter Description..."
                                  className={`form-control premium-input ${touched.description && errors.description ? "is-invalid" : ""}`}
                                />
                                <ErrorMessage component="div" name="description" className="invalid-feedback" />
                              </div>

                              <div className="form-group mb-4">
                                <label className="small text-muted font-weight-bold">Ticket Status</label>
                                <Field
                                  as="select"
                                  name="ticketStatus"
                                  className={`form-control premium-select ${touched.ticketStatus && errors.ticketStatus ? "is-invalid" : ""}`}
                                >
                                  <option value={4}>Select Status...</option>
                                  <option value={0}>Pending</option>
                                  <option value={1}>In Review</option>
                                  <option value={2}>Solved</option>
                                  <option value={3}>Closed</option>
                                </Field>
                                <ErrorMessage component="div" name="ticketStatus" className="invalid-feedback" />
                              </div>

                              {(() => {
                                const hasImages = rowValue?.issueImage1 || rowValue?.issueImage2;
                                if (hasImages) {
                                  return (
                                    <div className="form-group mb-4">
                                      <label className="small text-muted font-weight-bold d-block">Attachments</label>
                                      {rowValue?.issueImage1 && (
                                        <button
                                          type="button"
                                          className="btn btn-outline-info btn-block d-flex align-items-center justify-content-center mb-2"
                                          style={{ borderRadius: '8px', fontWeight: '600', height: '40px', gap: '8px' }}
                                          onClick={() => {
                                            setModalImageUrl(rowValue.issueImage1);
                                            setIsImageLoading(true);
                                            setShowImageModal(true);
                                          }}
                                        >
                                          <i className="fas fa-image"></i> View Image 1
                                        </button>
                                      )}
                                      {rowValue?.issueImage2 && (
                                        <button
                                          type="button"
                                          className="btn btn-outline-info btn-block d-flex align-items-center justify-content-center"
                                          style={{ borderRadius: '8px', fontWeight: '600', height: '40px', gap: '8px' }}
                                          onClick={() => {
                                            setModalImageUrl(rowValue.issueImage2);
                                            setIsImageLoading(true);
                                            setShowImageModal(true);
                                          }}
                                        >
                                          <i className="fas fa-image"></i> View Image 2
                                        </button>
                                      )}
                                    </div>
                                  );
                                }

                                const ticketImg = rowValue?.image || rowValue?.imageUrl || rowValue?.ticketImage || rowValue?.screenshot || rowValue?.file || rowValue?.attachment;
                                if (ticketImg) {
                                  return (
                                    <div className="form-group mb-4">
                                      <label className="small text-muted font-weight-bold d-block">Attachment</label>
                                      <button
                                        type="button"
                                        className="btn btn-outline-info btn-block d-flex align-items-center justify-content-center"
                                        style={{ borderRadius: '8px', fontWeight: '600', height: '40px', gap: '8px' }}
                                        onClick={() => {
                                          setModalImageUrl(ticketImg);
                                          setIsImageLoading(true);
                                          setShowImageModal(true);
                                        }}
                                      >
                                        <i className="fas fa-eye"></i> View Submitted Image
                                      </button>
                                    </div>
                                  );
                                }
                                return null;
                              })()}

                              <button
                                type="submit"
                                className="btn btn-primary premium-submit-btn shadow-sm btn-block"
                                disabled={buttonLoader}
                              >
                                {buttonLoader ? (
                                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                ) : null}
                                {openValue === 1 ? "Create Ticket" : "Update Status"}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </Form>
                  )}
                </Formik>
              </Box>
            </div>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div className="card ">
            <div className="pl-4 pr-4 pt-4 mb-2">
              <div className="row align-items-end">
                <div className="col-md-4">
                  <div className="form-group mb-0">
                    <label className="small text-muted font-weight-bold mb-2">Search Ticket</label>
                    <div className="position-relative">
                      <i className="fas fa-search text-muted position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, fontSize: '0.9rem' }}></i>
                      <input
                        className="form-control premium-search-input"
                        type="text"
                        placeholder="Search tickets..."
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body" style={{ overflow: "auto" }}>
              <table id="" className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Ticket ID</th>
                    <th>Date</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Status</th>
                    {accessObject?.bannerEdit == true && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {accessObject?.getBannerList == true ? (
                    !loader ? (
                      tableData.length > 0 ? (
                        tableData
                          ?.slice(pagination.start, pagination.end)
                          .map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1 + pagination.start}</td>
                              <td>{item.ticket_id || item.ticketCode || item.ticketNo || item.ticketId || (item._id ? `TCK-${item._id.substring(item._id.length - 8).toUpperCase()}` : 'N/A')}</td>
                              <td>
                                {moment(item.createdAt).format(
                                  "DD/MM/YYYY"
                                )}
                              </td>
                              <td>{item.title}</td>
                              <td>{item.description}</td>
                              <td>
                                {item.ticketStatus === 0
                                  ? "Pending"
                                  : item.ticketStatus === 1
                                    ? "In Review"
                                    : item.ticketStatus === 2
                                      ? "Solved"
                                      : item.ticketStatus === 3
                                        ? "Closed"
                                        : "-"}
                              </td>
                              <td className="d-flex justify-content-evenly ">
                                {accessObject?.bannerEdit == true && (
                                  <EditIcon
                                    className="mr-3 courser"
                                    onClick={() =>
                                      clickEditButton(item)
                                    }
                                  />
                                )}
                                {accessObject?.bannerDelete == true && (
                                  <ClearIcon
                                    className="courser text-danger"
                                    onClick={() =>
                                      warningWithConfirmMessage(item)
                                    }
                                  />
                                )}
                              </td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td colSpan={7} className="text-center py-5">
                            <div className="d-flex flex-column align-items-center justify-content-center">
                              <div className="mb-3 rounded-circle d-flex align-items-center justify-content-center" style={{ width: "80px", height: "80px", backgroundColor: "#f8fafc" }}>
                                <i className="fas fa-folder-open text-muted" style={{ fontSize: "32px" }}></i>
                              </div>
                              <h5 className="text-muted font-weight-bold mb-1">No Tickets Found</h5>
                              <p className="text-muted small mb-0">There are currently no tickets matching your search.</p>
                            </div>
                          </td>
                        </tr>
                      )
                    ) : null
                  ) : (
                    <tr
                      style={{ backgroundColor: "rgba(0,0,0,.05)" }}
                      className="text-center"
                    >
                      <td colSpan={7}>
                        <h5>Access Denied</h5>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {accessObject?.getBannerList == true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {accessObject?.getBannerList == true && totalData != 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={totalData}
              />
            )}
          </div>
        </div>
      )}
      {showImageModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(15, 23, 42, 0.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            backdropFilter: "blur(4px)"
          }}
          onClick={() => setShowImageModal(false)}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90%",
              maxHeight: "90%",
              backgroundColor: "#ffffff",
              padding: "8px",
              borderRadius: "12px",
              boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              style={{
                position: "absolute",
                top: "-15px",
                right: "-15px",
                backgroundColor: "#ef4444",
                color: "#ffffff",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)"
              }}
              onClick={() => setShowImageModal(false)}
            >
              &times;
            </button>
            {isImageLoading && (
              <div
                className="shimmer-placeholder"
                style={{
                  width: "350px",
                  height: "600px",
                  maxWidth: "90vw",
                  maxHeight: "70vh",
                  borderRadius: "8px"
                }}
              />
            )}
            <img
              src={getImageUrl(modalImageUrl)}
              alt="Submitted Attachment"
              onLoad={() => setIsImageLoading(false)}
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                borderRadius: "8px",
                objectFit: "contain",
                display: isImageLoading ? "none" : "block"
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}
